(function (app) {
    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Root", {
            url: "",
            component: "root",
            redirectTo: "Root.Policies"
        });
    }]);

    app.component("root", {
        templateUrl: "/App/States/Root/root.html",
        controller: rootController
    });

    rootController.$inject = ["accessTokenService"];
    function rootController(accessTokenService) {
        var $ctrl = this;
        $ctrl.hasAccess = accessTokenService.getAccessToken();
        $ctrl.title = "FIG";
        $ctrl.project = "Visualizer";
        $ctrl.currentYear = (new Date()).getFullYear();
    }
})(window.app);

